import { ButtonHTMLAttributes } from "react";
import "./Button.scss";

const Border: React.FC<ButtonHTMLAttributes<any>> = (props: any) => {
  const { children, className = "", ...rest } = props;
  return (
    <button {...rest} className={`${className} button border`}>
      {children}
    </button>
  );
};

export default Border;
